import { CategoryDto } from 'api/dto/Category.dto';
import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionOpinion } from 'model/QuestionOpinion';

export class QuestionOpinionMapper
  implements PageItemKindMapper<QuestionOpinion, PageItemApi.QuestionOpinionEntry>
{
  constructor() {}

  serialize(model: QuestionOpinion): PageItemApi.QuestionOpinionEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      category: model.category ? model.category.id : undefined,
      option1: model.options?.[0],
      option2: model.options?.[1],
      option3: model.options?.[2],
      option4: model.options?.[3],
      option5: model.options?.[4],
      reportedAs: model.reportedAs,
      notApplicable: model.notApplicable,
      required: model.isRequired ? 1 : 0,
      isRecommendedQuestion: model.isRecommendedQuestion,
      locale: model.locale,
      hasNotApplicableOption: model.hasNotApplicableOption,
      benchmarkItem: model.benchmarkItemId || null,
      trendItem: model.trendItemId || null,
    };
  }

  deserialize(entry: PageItemApi.QuestionOpinionEntry): QuestionOpinion {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      category: entry.category ? (entry.category as CategoryDto) : undefined,
      options: [entry.option1, entry.option2, entry.option3, entry.option4, entry.option5],
      reportedAs: entry.reportedAs,
      notApplicable: entry.notApplicable,
      isRequired: Boolean(entry.required),
      isRecommendedQuestion: entry.isRecommendedQuestion,
      locale: entry.locale,
      hasNotApplicableOption: entry.hasNotApplicableOption,
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.QuestionOpinion;
  }

  supportsDeserialize(entry: PageItemApi.ImageWidgetEntry): boolean {
    return entry.kind === PageItemKind.QuestionOpinion;
  }
}
